<app-loader [isLoading]="isLoading"></app-loader>

<div class="header">
    <div class="top">
        <a [routerLink]="returnLink" [queryParams]="{ tab: 'reglas' }">
            <h3>Vacaciones protocolos /</h3>
            <div class="breadcrumb">
                <mat-icon svgIcon="arrow back"></mat-icon>
                <h2>{{ isEditMode ? (rule.name || 'Editar regla') : 'Nueva regla' }}</h2>
            </div>
        </a>
    </div>
</div>

<form [formGroup]="ruleForm" class="content">
    <!-- Name field -->
    <h4>Nombre de la regla:</h4>
    <mat-form-field appearance="outline" id="title-form-field">
        <input type="text" matInput placeholder="Nombre de la regla" formControlName="name">
        @if (ruleForm.get('name')?.invalid && ruleForm.get('name')?.touched) {
        <mat-error>
            El nombre es requerido
        </mat-error>
        }
    </mat-form-field>

    <!-- Value field -->
    <h4>Valor:</h4>
    <mat-form-field appearance="outline" id="value-form-field">
        <input type="number" matInput placeholder="Valor" formControlName="value" min="0">
        @if (ruleForm.get('value')?.hasError('min') && ruleForm.get('value')?.touched) {
        <mat-error>
            El valor no puede ser negativo
        </mat-error>
        }
    </mat-form-field>

    <!-- Date range fields -->
    <h4>Rango de fechas:</h4>
    <div style="display: flex; gap: 20px; flex-direction: column;">
        <div style="display: flex; gap: 20px;">
            <mat-form-field appearance="outline" style="width: 20% !important;">
                <mat-label>Fecha inicio</mat-label>
                <input matInput [matDatepicker]="pickerStart" formControlName="date_range_start" placeholder="Fecha inicio">
                <mat-datepicker-toggle matIconSuffix [for]="pickerStart"></mat-datepicker-toggle>
                <mat-datepicker #pickerStart></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline" style="width: 20% !important;">
                <mat-label>Fecha fin</mat-label>
                <input matInput [matDatepicker]="pickerEnd" formControlName="date_range_end" placeholder="Fecha fin">
                <mat-datepicker-toggle matIconSuffix [for]="pickerEnd"></mat-datepicker-toggle>
                <mat-datepicker #pickerEnd></mat-datepicker>
            </mat-form-field>
        </div>
        @if (ruleForm.hasError('dateRangeIncomplete') && (ruleForm.get('date_range_start')?.touched || ruleForm.get('date_range_end')?.touched)) {
        <div class="error-message">
            Si completas una fecha, debes completar ambas fechas del rango
        </div>
        }
        @if (ruleForm.hasError('dateRangeInvalid') && (ruleForm.get('date_range_start')?.touched || ruleForm.get('date_range_end')?.touched)) {
        <div class="error-message">
            La fecha de fin debe ser mayor o igual a la fecha de inicio
        </div>
        }
    </div>

    <!-- Boolean field -->
    <h4>Días sueltos:</h4>
    <mat-slide-toggle formControlName="boolean_value">Permitidos</mat-slide-toggle>

    <br><br><br>
    <div class="buttons">
        <button mat-flat-button id="action" type="button" (click)="saveChanges()"
            [disabled]="isSubmitting || ruleForm.invalid">
            @if (isSubmitting) {
            {{ isEditMode ? 'Actualizando...' : 'Guardando...' }}
            } @else {
            {{ isEditMode ? 'Actualizar' : 'Guardar cambios' }}
            }
        </button>
        <button mat-flat-button id="cancel" type="button" (click)="cancel()">Cancelar</button>
    </div>
</form>
